import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { SIZES, FONTS, COLORS } from '../constants'

import { AntDesign } from '@expo/vector-icons';


export default function SolidBtn({ text, iconName, onPress }) {

  return (
    <>
      <TouchableOpacity
        style={styles.container}
        onPress={onPress}
      >
        <View style={styles.solidBtn}>
          {/* <MaterialIcons name="arrow-forward" size={48} color={COLORS.primary} /> */}
          <AntDesign name={iconName} size={24} color={COLORS.primary} />
          <Text style={styles.rightText}>
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 15,
    // marginTop: 5,
  },
  solidBtn: {
    backgroundColor: COLORS.accent,
    borderColor: COLORS.primary,
    borderRadius: 15,
    borderWidth: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: 300,
    height: 60,
  },
  rightText: {
    color: COLORS.primary,
    fontSize: 16
  }
})